import { lineString } from '@turf/helpers';
import { RoutesChange } from './../../model/services/routes.service';
import { RouteConfigDialogService } from './../dialogs/route-config-dialog/route-config-dialog.service';
import { RouteFeature } from './../../model/mapping/drawing/RouteFeature';
import { MapComponent } from './../map/map.component';
import { RouteID } from 'app/model/services/routes.service';
import { AnyHandler, TypedHandler } from './../../types/handlers';
import { SubscriptionMgr } from './../../model/SubscriptionMgr';
import { Dict } from './../../types/decorable';
import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import * as d3 from 'd3';
import { IFeatureContext, IFeature, Feature } from 'app/model/mapping/drawing/Feature';
import { PolyFeature } from 'app/model/mapping/drawing/PolyFeature';
import { LineFeature } from 'app/model/mapping/drawing/LineFeature';
import { PointFeature } from 'app/model/mapping/drawing/PointFeature';
import { PixoSpatial, PixoSpatialCoord, SpatialCoord, PixoPt } from 'app/model/mapping/Pixospatial';
//import { SLLayer, LayerGeomtypes } from 'src/app/model/sl-layer';

import { centroid, GeometryObject } from '@turf/turf';
import { StatefulCSS } from 'app/model/stateful_css';
import { ModalMessagerService } from '../dialogs/modal-messager/modal-messager.service';
import { RouteInfo, RouteService } from 'app/model/services/route.service';
import { RoutesService } from 'app/model/services/routes.service';
import { IDKeyTypes, IDManager, ObjID } from 'app/model/id-manager';
import { PointLike } from 'mapbox-gl';

export interface FeatureInfo {
  layer: RouteID;
  gid: number; // feature id
}

export interface ROIEvent {
  type: 'mouse' | 'touch';
  roiElement: SVGElement;
  location: PixoSpatialCoord | null;
  location2?: PixoSpatialCoord | null;
  action: 'clear' | 'start' | 'move' | 'end';
  left: boolean;
  right: boolean;
  middle: boolean;
}

export type DrawMode = 'feature' | 'roi' | 'merge'


@Component({
  selector: 'app-draw-pane',
  templateUrl: './draw-pane.component.html',
  styleUrls: ['./draw-pane.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DrawPaneComponent implements IFeatureContext, OnInit, OnDestroy {

  @ViewChild('svg', { static: true }) svg?: ElementRef;

  private geomType?: string;
  private gid?: string;
  private _ready = false;
  private mapCanvas?: HTMLCanvasElement;
  public selectedLayer: RouteID = 0;
  @Input('type')
  set type(newType: string) {
    this.geomType = newType;
    this.Clear();
  }

  get type(): string {
    return !!this.geomType ? this.geomType : '';
  }
  set domElement(e: HTMLElement) {
    // do nothing
  }
  @Output()
  get domElement(): HTMLElement {
    return this.domNode.nativeElement;
  }
  public idManager?: IDManager;
  private _map?: MapComponent;
  @Input()
  public set map(m: MapComponent | undefined) {
    this._map = m;
    this._map!.onMapMove.subscribe(() => {
      this.features.every((feature: RouteFeature) => {
        feature.ContextChanged();
        return true;
      });
    });
    this.SetIDManager();
    this.Refresh();
  }
  public get map(): MapComponent | undefined {
    return this._map;
  }
  private _spatialContext?: PixoSpatial;
  @Input() set spatialContext(pixo: PixoSpatial | undefined) {
    this._spatialContext = pixo;
    this.Refresh();
  }
  get spatialContext(): PixoSpatial | undefined {
    return this._spatialContext;
  }
  @HostBinding('style.width') styleWidth!: string;
  @HostBinding('style.height') styleHeight!: string;

  @Input() width: any = '100%';

  @Input() height: any = '100%';


  @Output() roi = new EventEmitter<ROIEvent>();

  @Output() typeChange = new EventEmitter<string>();
  get hasVertices() {
    if (!this.GetSelectedFeature()) {
      return false;
    }

    return this.GetSelectedFeature().hasVertices;

  }
  @Output() hasVerticesChange = new EventEmitter<boolean>();

  @HostBinding('class.active')
  private _isOn: boolean = false;
  @Input()
  public set isOn(isIt: boolean) {
    this._isOn = isIt;
    if (this._isOn) this.TurnOn();
    if (!this._isOn) this.TurnOff();
    this.UpdateSize();
    this.Refresh();
  }
  public get isOn(): boolean {
    return this._isOn;
  }
  @Output() isOnChange = new EventEmitter<boolean>();



  @Input() isROIOn = false;


  @HostBinding('class.hidden') isHidden = true;

  @Output()
  geometryChange = new EventEmitter<Dict>();

  @Output()
  selectionChange = new EventEmitter<Dict>();

  public layer?: RouteID;
  private d3svg: any;
  private features: Array<RouteFeature> = [];
  private selectedFeature?: Feature;
  private started = false;
  private newFeatureOk = false;

  private _drawMode: DrawMode = 'feature';
  public set drawMode(mode: DrawMode) {
    this._drawMode = mode;
    this.modeStates.SetState(mode);
    this.drawModeChange.emit(mode);
  }
  public get drawMode(): DrawMode {
    return this.modeStates.GetCurrentState() as DrawMode;
  }
  public drawModeChange = new EventEmitter<DrawMode>();
  public WindowUpHandler?: TypedHandler<MouseEvent>;
  private drawModes = ['feature'];
  private drawWidth = 0;
  private drawHeight = 0;
  private ROIElement?: any;
  private handledMouse = false;
  private handledTouch = false;
  private drawingOn = false;
  private stateMgr = new StatefulCSS();
  private modeStates = new StatefulCSS();
  protected featureContext?: IFeatureContext;
  protected subscriptions = new SubscriptionMgr();

  constructor(
    public domNode: ElementRef<HTMLDivElement>,
    private messager: ModalMessagerService,
    private cdr: ChangeDetectorRef,
    private routeSvc: RouteService,
    private routesSvc: RoutesService,
    private routeDlg: RouteConfigDialogService
  ) { }
  SetIDManager() {
    if (!this.map?.project?.idManager) {
      window.requestAnimationFrame(() => {
        this.SetIDManager();
      })
      return;
    }
  }
  ngOnInit() {
    this.stateMgr.SetMachine(this.domElement);
    this.stateMgr.SetPrefix('drawing');
    this.stateMgr.AddState('on');
    this.stateMgr.AddState('off');
    this.modeStates.SetMachine(this.domElement);
    this.modeStates.SetPrefix('draw-mode');
    this.modeStates.AddState('feature');
    this.modeStates.AddState('roi');
    this.modeStates.AddState('merge');

    this.modeStates.SetState(this._drawMode);

    if (this.isOn) {
      this.TurnOn();
    } else {
      this.TurnOff();
    }
    if (!this.svg) throw new Error('svg element not ready');
    this.d3svg = d3.select(this.svg.nativeElement);
    this.d3svg.attr('fill', '#0005');
    const defs = this.d3svg.append('defs');
    const filter = defs.append('filter')
      .attr('id', 'glow');
    filter.append('feGaussianBlur')
      .attr('stdDeviation', '3.5')
      .attr('result', 'coloredBlur');
    const feMerge = filter.append('feMerge');
    feMerge.append('feMergeNode')
      .attr('in', 'coloredBlur');
    feMerge.append('feMergeNode')
      .attr('in', 'SourceGraphic');
    this.featureContext = {
      updateHandler: (feature: Feature) => {
        this.hasVerticesChange.emit(feature.hasVertices);
      }
    };
    this.featureContext.roiGroup = this.d3svg.append('g');
    this.ROIElement = this.featureContext.roiGroup.append('rect')
      .attr('x', '0')
      .attr('y', '0')
      .attr('width', 0)
      .attr('height', 0)
      .classed('hidden', true)
      .classed('roi', true);


    this.featureContext.polygonGroup = this.d3svg.append('g');
    this.featureContext.segmentGroup = this.d3svg.append('g');
    this.featureContext.pointGroup = this.d3svg.append('g');
    this.featureContext.polyLabels = this.d3svg.append('g');
    this.featureContext.segmentLabels = this.d3svg.append('g');
    this.featureContext.pointLabels = this.d3svg.append('g');


    this.featureContext.container = this.d3svg.node();
    this.width = this.domNode.nativeElement.style.width;
    this.height = this.domNode.nativeElement.style.height;

    this.d3svg.on('click', (event: any) => {
      if (this.drawMode !== 'merge') {
        if (event.target.nodeName !== 'svg') {
          return;
        }
      }
      if (this.drawMode === 'roi') {
        return;
      }
      if (this.isOn === false) {
        return;
      }
      const x = event.layerX;
      const y = event.layerY;
      if (['feature', 'merge'].indexOf(this.drawMode) > -1) {
        if (this.gid === null) {
          if (this.newFeatureOk === false) {
            this.messager.Confirm(
              'A feature is not currently being edited, if you are intentionally creating a new feature? Click OK to proceed editing your new feature.',
              () => {
                this.newFeatureOk = true;
                this.AddVertex(x, y);
              }, () => { }
            );
            return;
          }
        }
      }
      if (this.drawMode === 'merge') {
        this.drawMode = 'feature';
        if (event.target.nodeName !== 'svg') {
          if (!!this._mergeInfo) {
            this._mergeInfo.route.feature.Select(this._mergeInfo.feature.id, this._mergeInfo.route.id);
          }
          const id = event.target.attributes['data-guid'].value
          const pt = this.map!.project!.idRegistry!.Get(id);
          (this.selectedFeature as RouteFeature).AddExistingVertex(pt);
          // (this.selectedFeature as RouteFeature).Select(pt.id, (this.selectedFeature as RouteFeature).id)
          this._mergeInfo = undefined;
          return;
        }
      }
      this.AddVertex(x, y);

    });

    // tslint:disable-next-line: no-string-literal
    this.started = true;
    /*if (this.geomType !== null) {
      if (this.features.length === 0) {
        this.NewFeature();
      }
    }*/
    this.subscriptions.Subscribe(RoutesService.onChange, (event: RoutesChange) => {
      switch (event.change) {
        case 'delete-all':
          {
            const route = this.routeSvc.GetRoute(event.route);
            route?.feature?.DeleteGeometry();
          }
          return;
        case 'delete-selected':
          {
            const route = this.routeSvc.GetRoute(event.route);
            const feature = route.feature?.GetSelectedInfo();
            if (feature?.type !== 'point') return;
            route.feature?.RemoveSelected();

          }
          return;
        case 'jump-to-route':
          const route = this.routeSvc.GetRoute(event.route);
          if (!(route && route.feature)) return;
          const extent = route.feature?.GetExtent();
          const minDim = Math.min(this.domElement.clientWidth, this.domElement.clientHeight);
          this.map?.ui.fitBounds(extent, { padding: minDim / 8 });
          return;
        case 'jump-to-feature':
          if (!(this.map && this.map.project && event.feature)) return;
          const feature = this.map.project.idRegistry.Get(event.feature);
          if (!feature) return;
          switch (feature.type) {
            case 'point':
              this.map.ui.jumpTo({ center: [feature.coord.spatial.lng, feature.coord.spatial.lat] })
              break;
            case 'segment':
              const from = feature.from.coord.spatial;
              const to = feature.to.coord.spatial;
              const line = lineString([[from.lng, from.lat], [to.lng, to.lat]]);
              const pt = centroid(line).geometry.coordinates;
              if (pt) {
                this.map.ui.jumpTo({ center: [pt[0], pt[1]] })
              }
              return;

          }
        case 'gps-add':
          {
            const route = this.routeSvc.GetRoute(event.route);
            route.feature?.GPSAddVertex();
            return;
          }
          // this.GPSAddVertex(event.route);
          break;
        case 'gps-update':
          this.GPSUpdateSelected(event.route);
          break;
      }
    });
    this.WindowUpHandler = (event: MouseEvent) => {
      if ((event.buttons & 1) === 0) {
        this.HandleROIMouseEvent('clear', event);
        if (!!this.WindowUpHandler) {
          window.removeEventListener('mouseup', this.WindowUpHandler);
        }
      }
    };
    this._ready = true;
    this.Refresh();
  }
  private _mergeInfo?: { route: any, feature: any };
  StartMerge(mergeInfo: { route: any, feature: any }) {
    this._mergeInfo = mergeInfo;
    this.drawMode = 'merge';
  }
  SetSpatialContext(context: PixoSpatial) {
    this.spatialContext = context;
    // this.Clear().NewFeature();
  }
  Clear(newOk: boolean = false): DrawPaneComponent {
    for (const feature of this.features) {
      feature.Remove();

    }
    if (this.WindowUpHandler) {
      window.removeEventListener('mouseup', this.WindowUpHandler);
    }
    if (newOk === false) {
      this.gid = undefined;
    }
    this.newFeatureOk = newOk;
    this.features = [];
    return this;
  }
  NewFeature(keepId = false): DrawPaneComponent | undefined {
    if (this.started === false) {
      return undefined;
    }
    if (!this.featureContext) return undefined;

    this.gid = keepId ? this.gid : undefined;
    let feature: RouteFeature = new RouteFeature(this.featureContext);
    if (!!feature) {
      this.subscriptions.Subscribe(
        feature.selectionChange, (info: Dict) => {
          this.selectionChange.emit(info);
        });
      this.subscriptions.Subscribe(
        feature.geometryChange, (info: Dict) => {
          this.geometryChange.emit(info);
        });
      this.features.push(feature);
    }
    this.selectedFeature = feature;
    this.selectionChange.emit(this);
    return this;
  }
  AddVertex(x: number, y: number) {
    if (!this.spatialContext) return;
    const pt = { x: (x), y: (y) };
    const coord = this.spatialContext.PixoSpatialCoord(this.spatialContext.PixoPt(pt));
    let extant;
    const routes = this.map?.project?.idRegistry.GetByType(IDKeyTypes.Route);
    if (!routes) return;
    for (const routeId in routes) {
      const route = this.routeSvc.GetRoute(Number(routeId));
      if (!route) continue;
      extant = route.feature?.HasVertex(coord);
      if (!extant) continue;
      break;
    }

    if (!!this.selectedFeature) {
      const info = this.selectedFeature.GetSelectedInfo();
      if (!!extant) {
        (this.selectedFeature as RouteFeature).AddExistingVertex(extant);
      } else {
        this.selectedFeature.AddVertex({ x: (x), y: (y) });
      }
    }
    if (this.drawMode === 'merge') {
      this.drawMode = 'feature';
    }
  }

  DeleteVertex() {
    if (!this.selectedFeature) return;

    this.selectedFeature.RemoveSelected();
    this.geometryChange.emit(this.selectedFeature);
  }

  RemoveFeature(): void {
    if (!this.selectedFeature) return;
    this.features.slice(this.features.indexOf(this.selectedFeature as RouteFeature, 1));
    this.selectedFeature.Remove();
    this.selectedFeature = undefined;
    if (this.features.length > 0) {
      this.SelectFeature(this.features[this.features.length - 1]);
    }
    this.selectionChange.emit(this.GetSelectedFeature());
  }
  SelectFeature(feature: Feature): void {
    if (!feature) return;
    if (!!this.selectedFeature) {
      if (this.selectedFeature.id === feature.id) {
        return;
      }
      this.selectedFeature.DeselectFeature();
    }
    this.selectedFeature = feature;
    this.selectedFeature.SelectFeature();
  }
  RemoveFeatureSelection(): void {
    if (!this.selectedFeature) return;
    this.selectedFeature.RemoveSelected();
  }

  ngOnDestroy(): void {
    this.subscriptions.CancelSubscriptions();
    for (const g in this.featureContext) {
      if (this.featureContext.hasOwnProperty(g)) {
        const entry = (this.featureContext as any)[g];
        entry.destroy();
      }
    }
    if (!!this.spatialContext) {
      this.spatialContext.Detatch();
    }
  }
  private TurnOn(): void {
    if (!this._isOn) {
      this.isOn = true;
      return;
    }
    this.stateMgr.SetState('on');
    const element = this.domNode.nativeElement;
    this.isHidden = false;

    // this.drawMode = 'feature';
    /*if (this.layer && this.layer.SLMap) {
      this.layer.SLMap.DigitizerUpdated();
    }*/
    element.classList.toggle('active', this.isOn);
    this.isOnChange.emit(true);
    this.Refresh();


  }
  private TurnOff() {
    if (!!this._isOn) {
      this.isOn = false;
      return;
    }
    this.stateMgr.SetState('off');
    this.isOnChange.emit(false);
    this.Refresh();
  }

  GPSUpdateSelected(routeId: ObjID): void {
    const route = this.routeSvc.GetRoute(routeId as number);
    if (!route) return;
    const info = route.feature!.GetSelectedInfo();
    if (!info) return;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        (info.coord as PixoSpatialCoord).UpdateSpatial(position.coords.longitude, position.coords.latitude,
          position.coords.accuracy, position.timestamp, position.coords.altitude, position.coords.altitudeAccuracy,
          position.coords.heading, position.coords.speed);
        this.geometryChange.emit(this.selectedFeature);
      });
    } else {
      this.messager.Notify('Geolocation is not supported by this browser');

    }
  }
  GPSAddVertex(routeId: ObjID) {
    const me = this;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        me.AddFromGPS(routeId, position);
      });

    } else {
      this.messager.Notify('Geolocation is not supported by this browser');

    }
  }
  AddFromGPS(routeId: ObjID, position: GeolocationPosition) {
    if (!this.spatialContext) return;
    const route = this.routeSvc.GetRoute(routeId as number);
    if (!(route && route.feature)) return;
    const spatial = this.spatialContext.SpatialCoord(position.coords, 'longitude', 'latitude');
    const pixo = spatial.convert();
    const vertex = route.feature.AddVertex(pixo);
    const info = route.feature.GetSelectedInfo();
    if (info.type === 'point') {
      info.coord.UpdateSpatial(position.coords.longitude, position.coords.latitude,
        position.coords.accuracy, position.timestamp, position.coords.altitude, position.coords.altitudeAccuracy,
        position.coords.heading, position.coords.speed);
      this.geometryChange.emit(this.selectedFeature);
    }
  }
  UpdateFromGPS(position: GeolocationPosition, accurate: boolean = false) {
    if (!this.spatialContext) return;
    if (!this.selectedFeature) return;
    const spatial = this.spatialContext.SpatialCoord(position.coords, 'longitude', 'latitude');
    const pixo = spatial.convert();

    const info = this.selectedFeature.GetSelectedInfo();
    if (info.type === 'point') {
      info.coord.UpdateSpatial(position.coords.longitude, position.coords.latitude,
        position.coords.accuracy, position.timestamp, position.coords.altitude, position.coords.altitudeAccuracy,
        position.coords.heading, position.coords.speed, accurate);
      this.geometryChange.emit(this.selectedFeature);
    }
  }
  UpdateAll() {
    for (const feature of this.features) {
      feature.ContextChanged();
    }
  }
  ShowFeature(featureInfo: FeatureInfo, readyHandler: AnyHandler, force: boolean = false) {

    this.layer = featureInfo.layer;
    /*if (this.layer.SLMap.digitizer) {
      this.layer.SLMap.digitizer.SetDrawPane(this);
    }*/
    /*this.featureSvc.GetGeoJSON(featureInfo.layer, featureInfo.gid).then((response) => {
      this.SetLayer(featureInfo.layer);
      this.type = featureInfo.layer.geom;
      // this.Clear().NewFeature();

      this.gid = '' + featureInfo.gid;
      if (!!this.features[0].FromGeoJSONGeom) {
        this.features[0].FromGeoJSONGeom(response.record.json_geom);
        this.layer.SLMap.digitizer.SetDrawPaneFeatureReady(this.features[0]);
        readyHandler();
      }

    });
    */
  }

  Cancel() {
    // this.Clear().NewFeature();
    // // this.layer.SLMap.Update(this.layer);
  }
  EnableROI() {
    /*if ((this.isROIOn === true) || !this.map) {
      return;
    }
    //this.drawModes.push(this.drawMode);
    this.drawMode = 'roi';
    this.TurnOn();
    const viewArea: any = this.map.component.GetViewArea();
    const width = viewArea.right - viewArea.left;
    const height = viewArea.bottom - viewArea.top;
    this.drawWidth = width;
    this.drawHeight = height;
    $(this.ROIElement.nativeElement).toggleClass('hidden', false);

    if (this.featureContext.drawRect === undefined) {
      this.featureContext.drawRect = this.d3svg.append('rect');

      this.featureContext.drawRect.attr('x', 0).attr('y', 0)
        .attr('width', this.drawWidth)
        .attr('height', this.drawHeight)
        .attr('fill', '#0000');


      this.featureContext.drawRect.on('touchstart', (event = null) => {
        this.handledTouch = true;
        if (d3.event.cancelable === true) {
          d3.event.preventDefault();
        }
        this.HandleROITouchEvent('start', d3.event);

      }).on('touchmove', (event) => {
        if (d3.event.cancelable === true) {
          d3.event.preventDefault();
        }
        this.HandleROITouchEvent('move', d3.event);
      }).on('touchend', (event) => {

        if (d3.event.cancelable === true) {
          d3.event.preventDefault();
        }
        // this.d3svg.on('touchmove', null).on('touchend', null);
        this.HandleROITouchEvent('end', d3.event);

      }).on('mousemove', (event) => {
        if (d3.event.cancelable === true) {
          d3.event.preventDefault();
        }
        this.HandleROIMouseEvent('move', d3.event);
      }).on('mouseup', (event) => {
        if (d3.event.type === 'touch') {
          // return;
        }
        if (d3.event.cancelable === true) {
          d3.event.preventDefault();
        }
        if (event !== undefined) {
          if (event.target !== this.ROIElement) {
            return;
          }
        }
        this.HandleROIMouseEvent('end', d3.event);
      }).on('mousedown', (event) => {
        if (d3.event.type === 'touch') {
          // return;
        }
        if (event !== undefined) {
          if (event.target !== this.ROIElement) {
            return;
          }
        }
        if (d3.event.cancelable === true) {
          d3.event.preventDefault();
        }
        this.HandleROIMouseEvent('start', d3.event);
      }).on('mouseenter', (event) => {
        if (d3.event.cancelable === true) {
          d3.event.preventDefault();
        }

        if (d3.event.buttons > 0) {
          this.HandleROIMouseEvent('move', d3.event);
        } else {
          this.HandleROIMouseEvent('clear', d3.event);
        }

      });
    }
    // this.Clear();
    */
  }
  HandleROIMouseEvent(mode: 'clear' | 'start' | 'move' | 'end', event: MouseEvent) {
    /*
    if (mode === 'clear') {
      this.roi.emit({
        type: 'mouse',
        roiElement: this.ROIElement,
        location: this.spatialContext.PixoSpatialCoord(this.spatialContext.PixoPt({ x: -1, y: -1 })),
        action: mode,
        left: (event.buttons & 1) === 1,
        middle: (event.buttons & 4) === 4,
        right: (event.buttons & 2) === 2
      });
      window.removeEventListener('mouseup', this.WindowUpHandler);
      return;
    }
    const pt = { x: event.offsetX, y: event.offsetY };
    if (!(!!this.featureContext.drawRect)) {
      return;
    }

    pt.x += this.svg.nativeElement.clientLeft;
    pt.y += this.svg.nativeElement.clientTop;
    if (event.cancelable === true) {
      event.preventDefault();
    }
    if (event.buttons === 0) {
      if (mode !== 'end') {
        return;
      }
    }
    window.addEventListener('mouseup', this.WindowUpHandler);
    const point = this.spatialContext.PixoPt(pt);
    const downCoord = this.spatialContext.PixoSpatialCoord(point);
    this.roi.emit({
      type: 'mouse',
      roiElement: this.ROIElement,
      location: downCoord,
      action: mode,
      left: (event.buttons & 1) === 1,
      middle: (event.buttons & 4) === 4,
      right: (event.buttons & 2) === 2
    });
    d3.select(this.ROIElement.nativeElement).classed('hidden', false);
    */
  }
  HandleROITouchEvent(mode: 'start' | 'move' | 'end', event: any) {
    /*
    if (event.cancelable === true) {
      event.preventDefault();
    }

    const touches: TouchList = (mode === 'start') ? event.touches : event.changedTouches;


    const rect: ClientRect = (this.svg.nativeElement as SVGElement).getBoundingClientRect();
    const touchPt = this.spatialContext.PixoPt({
      x: (touches.item(0).pageX - rect.left),
      y: (touches.item(0).pageY - rect.top)
    });
    const touchCoord = this.spatialContext.PixoSpatialCoord(touchPt);
    const start = {
      x: Number(this.ROIElement.attr('x')),
      y: Number(this.ROIElement.attr('y'))
    };
    if ((mode === 'end')) {
      const end: PixoPt = this.spatialContext.PixoPt(
        {
          x: (Number(this.ROIElement.attr('width')) + start.x),
          y: (Number(this.ROIElement.attr('height')) + start.y)
        }
      );

      const endCoord = this.spatialContext.PixoSpatialCoord(end);
      this.roi.emit({
        type: 'touch',
        roiElement: this.ROIElement,
        location: endCoord,
        action: 'end',
        left: touches.length > 0,
        middle: touches.length > 2,
        right: touches.length > 1
      });
      return;
    }
    let touchCoord2 = null;
    if (touches.length > 1) {
      const rect2: ClientRect = (this.svg.nativeElement as SVGElement).getBoundingClientRect();
      const touchPt2 = this.spatialContext.PixoPt({
        x: touches.item(1).pageX - rect2.left,
        y: touches.item(1).pageY - rect2.top
      });
      touchCoord2 = this.spatialContext.PixoSpatialCoord(touchPt2);
    }
    this.roi.emit({
      type: 'touch',
      roiElement: this.ROIElement,
      location: touchCoord,
      location2: touchCoord2,
      action: mode,
      left: touches.length > 0,
      middle: touches.length > 2,
      right: touches.length > 1
    });

    */

  }

  DisableROI() {
    /*if (this.isROIOn !== false) {
      this.isROIOn = false;
    }

    this.ROIElement.attr('x', -1)
      .attr('y', -1)
      .attr('width', 0)
      .attr('heigh', 0)
      .classed('hidden', true);
    //if ((this.drawMode === 'roi') && (this.drawModes.length !== 0)) {
    this.drawMode = 'feature';
    // }
    this.d3svg.on('mousemove', null).on('mouseup', null).on('mousedown', null);
    this.d3svg.on('touchstart', null).on('touchmove', null).on('touchend', null);
    window.removeEventListener('mouseup', this.WindowUpHandler);
    // this.Clear().NewFeature();
    if (!!this.featureContext.drawRect) {
      this.featureContext.drawRect.remove();
      delete this.featureContext.drawRect;
    }
    */

  }

  UpdateROI(x: number, y: number, width: number, height: number) {
    /*
    if (this.drawMode === 'roi') {

      this.ROIElement
        .attr('x', x)
        .attr('y', y)
        .attr('width', width)
        .attr('height', height)
        .classed('hidden', false)
        .style('filter', 'url(#glow)');
    }
    */
  }
  UpdateSize(width?: string, height?: string) {
    if (!width && !height) {
      if (!this.mapCanvas) {
        const items = window.document.getElementsByClassName('mapboxgl-canvas');
        if (items.length > 0) {
          this.mapCanvas = items.item(0) as HTMLCanvasElement;

        } else {
          return;
        }
        width = this.mapCanvas?.style.width;
        height = this.mapCanvas?.style.height;
      }
    }
    if (!width && !height) return;
    this.styleWidth = '100%';// width as string;
    this.styleHeight = '100%'; //height as string;
    this.drawWidth = this.width.split('p').shift();
    this.drawHeight = this.height.split('p').shift();
    if (!!this.featureContext?.drawRect) {
      this.featureContext.drawRect.attr('width', this.drawWidth);
      this.featureContext.drawRect.attr('height', this.drawHeight);
    }
  }
  GetSelectedFeature(): Feature {
    return this.selectedFeature as Feature;
  }
  AddRouteLayer(route: RouteInfo) {
    if (!this.featureContext) return;
    const feature = new RouteFeature(this.featureContext, this.spatialContext!);
    feature.id = route.id;
    route.feature = feature;
    if (!!feature) {
      this.subscriptions.Subscribe(
        feature.selectionChange, (info: Dict) => {
          this.selectionChange.emit(info);
        });
      this.subscriptions.Subscribe(
        feature.geometryChange, (info: Dict) => {
          this.geometryChange.emit(info);
        });
      this.features.push(feature);
    }
    this.features.push(feature);
  }
  RemoveRouteLayer(routeID: RouteID) {
    const route = this.routeSvc.GetRoute(routeID);
    if (!!route && !!route.feature) {
      route.feature.Remove();
      route.feature = undefined;
    }
  }
  Refresh() {
    if (this._ready) {
      this.cdr.detectChanges();
    }
  }
  SetMapLayer(routeID: RouteID) {
    this.selectedLayer = routeID;
    const route = this.routeSvc.GetRoute(routeID);
    if (!!this.selectedFeature) {
      this.selectedFeature.DeselectFeature();
    }
    if (!!route?.feature) {
      this.selectedFeature = route.feature
      this.selectedFeature?.SelectFeature();
    }
    this.Refresh();
  }
  updateHandler(feature: Feature): void {

  }
}
